function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ownerDocument from '../utils/ownerDocument';
function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  // eslint-disable-next-line react/no-find-dom-node
  return ReactDOM.findDOMNode(container) || defaultContainer;
}
function getOwnerDocument(element) {
  // eslint-disable-next-line react/no-find-dom-node
  return ownerDocument(ReactDOM.findDOMNode(element));
}
class Portal extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "getMountNode", () => this.mountNode);
  }
  componentDidMount() {
    this.setMountNode(this.props.container);
    if (!this.props.disablePortal) this.forceUpdate(this.props.onRendered);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
      this.setMountNode(this.props.container);
      if (!this.props.disablePortal) this.forceUpdate(this.props.onRendered);
    }
  }
  componentWillUnmount() {
    this.mountNode = null;
  }
  setMountNode(container) {
    if (this.props.disablePortal) {
      // eslint-disable-next-line react/no-find-dom-node
      this.mountNode = ReactDOM.findDOMNode(this).parentElement;
      return;
    }
    this.mountNode = getContainer(container, getOwnerDocument(this).body);
  }
  render() {
    const {
      children,
      disablePortal
    } = this.props;
    if (disablePortal) {
      return children;
    }
    return this.mountNode ? /*#__PURE__*/ReactDOM.createPortal(children, this.mountNode) : null;
  }
}
Portal.propTypes = {
  children: PropTypes.node.isRequired,
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  disablePortal: PropTypes.bool,
  onRendered: PropTypes.func
};
Portal.defaultProps = {
  disablePortal: false
};
export default Portal;